import type { SiteStatus } from '@sine/sine-core-api-types';

export const BILLING_MODE = {
  OFF: 'off',
  CREDIT_CARD: 'credit_card',
};

export const BILLING_CYCLE = {
  YEARLY: 'year',
  MONTHLY: 'month',
  DAILY: 'day',
};

// core-api-types has `SiteStatus` enum, but can't use as enum coz type dec only :(
type SiteStatusKey = keyof typeof SiteStatus;
type SiteStatusValue = `${SiteStatus}`;

export const SITE_STATUS: Record<SiteStatusKey, SiteStatusValue> = {
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  ARCHIVED: 'Archived',
  TEMPLATE: 'Template',
} as const;
